import React, { useState, useEffect } from 'react';
import FeedbackService from '../../modules/services/Feedbackservice';
import '../css/boletos.css'; // Reutilizando CSS existente para manter padrão
import { FaStar } from 'react-icons/fa'; // Usaremos estrelas para a nota (opcional)

function RegistroFeedback({ cliente }) {
    const [areas, setAreas] = useState([]);
    const [formData, setFormData] = useState({
        cdFeedbackArea: '',
        vlAvaliacao: 0,
        dsFeedbackCliente: ''
    });
    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState({ texto: '', tipo: '' });

    useEffect(() => {
        carregarAreas();
    }, []);

    const carregarAreas = async () => {
        try {
            const response = await FeedbackService.listarAreas();
            if (response.status === 'OK') {
                setAreas(response.conteudo);
            }
        } catch (error) {
            console.error("Erro ao carregar áreas", error);
        }
    };

    const handleStarClick = (nota) => {
        setFormData({ ...formData, vlAvaliacao: nota });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMensagem({ texto: '', tipo: '' });

        if (!formData.cdFeedbackArea) {
            setMensagem({ texto: 'Selecione uma área.', tipo: 'erro' });
            setLoading(false);
            return;
        }
        if (formData.vlAvaliacao === 0) {
            setMensagem({ texto: 'Por favor, dê uma nota de avaliação entre 1 e 10.', tipo: 'erro' });
            setLoading(false);
            return;
        }
        if (!formData.dsFeedbackCliente.trim()) {
            setMensagem({ texto: 'Escreva seu comentário.', tipo: 'erro' });
            setLoading(false);
            return;
        }

        try {
            const payload = {
                cdCliente: cliente.cdCliente,
                cdFeedbackArea: formData.cdFeedbackArea,
                dsFeedbackArea: areas.find(a => a.cdFeedbackArea == formData.cdFeedbackArea)?.dsFeedbackArea,
                vlAvaliacao: formData.vlAvaliacao,
                dsFeedbackCliente: formData.dsFeedbackCliente,
                // nmUsuario: cliente.razaoSocial // Opcional se quiser mandar quem registrou
            };

            const response = await FeedbackService.registrarFeedback(payload);

            if (response.status === 'OK') {
                setMensagem({ texto: 'Feedback enviado com sucesso! Obrigado.', tipo: 'sucesso' });
                setFormData({ cdFeedbackArea: '', vlAvaliacao: 0, dsFeedbackCliente: '' });
            } else {
                setMensagem({ texto: response.mensagem, tipo: 'erro' });
            }
        } catch (error) {
            setMensagem({ texto: 'Erro ao enviar feedback.', tipo: 'erro' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="dashboard-painel boletos-painel">
            <h3 className="titulo">Enviar Feedback</h3>
            <p className="texto">Sua opinião é muito importante para nós. Avalie nossos serviços.</p>

            {mensagem.texto && (
                <div style={{ 
                    padding: '10px', 
                    marginBottom: '15px', 
                    borderRadius: '5px',
                    backgroundColor: mensagem.tipo === 'erro' ? '#f8d7da' : '#d4edda',
                    color: mensagem.tipo === 'erro' ? '#721c24' : '#155724',
                    border: `1px solid ${mensagem.tipo === 'erro' ? '#f5c6cb' : '#c3e6cb'}`
                }}>
                    {mensagem.texto}
                </div>
            )}

            <form onSubmit={handleSubmit} style={{ maxWidth: '600px' }}>
                
                {/* SELEÇÃO DE ÁREA */}
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#495057' }}>Área:</label>
                    <select 
                        className="input-filtro" 
                        style={{ width: '100%' }}
                        value={formData.cdFeedbackArea}
                        onChange={(e) => setFormData({...formData, cdFeedbackArea: e.target.value})}
                    >
                        <option value="">Selecione a área...</option>
                        {areas.map(area => (
                            <option key={area.cdFeedbackArea} value={area.cdFeedbackArea}>
                                {area.dsFeedbackArea}
                            </option>
                        ))}
                    </select>
                </div>

                {/* AVALIAÇÃO (ESTRELAS OU NOTA) */}
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#495057' }}>
                        Avaliação (1 a 10): <span style={{fontSize: '12px', fontWeight: 'normal'}}>(1 = Ruim, 10 = Excelente)</span>
                    </label>
                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((nota) => (
                            <button
                                key={nota}
                                type="button"
                                onClick={() => handleStarClick(nota)}
                                style={{
                                    width: '35px',
                                    height: '35px',
                                    borderRadius: '50%',
                                    border: formData.vlAvaliacao >= nota ? 'none' : '1px solid #dee2e6',
                                    backgroundColor: formData.vlAvaliacao >= nota 
                                        ? (nota <= 6 ? '#dc3545' : nota <= 8 ? '#ffc107' : '#28a745') // Cores NPS
                                        : 'white',
                                    color: formData.vlAvaliacao >= nota ? 'white' : '#495057',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    transition: 'all 0.2s'
                                }}
                            >
                                {nota}
                            </button>
                        ))}
                    </div>
                </div>

                {/* COMENTÁRIO */}
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#495057' }}>Comentário:</label>
                    <textarea
                        className="input-filtro"
                        style={{ width: '100%', height: '100px', resize: 'vertical' }}
                        placeholder="Conte-nos mais sobre sua experiência..."
                        value={formData.dsFeedbackCliente}
                        onChange={(e) => setFormData({...formData, dsFeedbackCliente: e.target.value})}
                        maxLength={500}
                    />
                    <div style={{ textAlign: 'right', fontSize: '12px', color: '#6c757d' }}>
                        {formData.dsFeedbackCliente.length}/500
                    </div>
                </div>

                <button 
                    type="submit" 
                    className="download-btn btn-aplicar-todos"
                    disabled={loading}
                    style={{ width: '100%', padding: '12px' }}
                >
                    {loading ? 'Enviando...' : 'Enviar Feedback'}
                </button>
            </form>
        </div>
    );
}

export default RegistroFeedback;